import React, { useState, useEffect } from 'react';
import { editorToolbarOptions } from '../../marketplace-custom-config';
import { EditorState, convertToRaw, convertFromRaw, getDefaultKeyBinding, KeyBindingUtil } from 'draft-js'
import { Editor } from 'react-draft-wysiwyg';

import css from './TextEditor.module.css';
import classNames from 'classnames';

const { hasCommandModifier } = KeyBindingUtil;

const TextEditor = props => {

  const { fieldValue, label, placeholder, input, meta, isRequired } = props

  const fieldValueToString = !!fieldValue ? JSON.stringify(fieldValue) : JSON.stringify('');
  const fieldValueToObject = JSON.parse(fieldValueToString);

  const validContent = fieldValueToObject.indexOf("blocks") !== -1;
  const [editorState, setEditorState] = useState(() => EditorState.createEmpty());


  const myKeyBindingFn = (e) => {
    if (e?.keyCode === 90 && e?.ctrlKey && hasCommandModifier(e)) {
      return 'myeditor-save';
    }
    return getDefaultKeyBinding(e);
  }

  useEffect(() => {
    if (!!fieldValue?.length) {

      const contentForOldListing = {
        "entityMap": {},
        "blocks": [{
          "key": "637gr", "text": `${fieldValueToString.replaceAll('"', '')}`,
          "type": "unstyled", "depth": 0,
          "inlineStyleRanges": [],
          "entityRanges": [],
          "data": {}
        }]
      };

      if (validContent) {
        const content = convertFromRaw(JSON.parse(fieldValue))
        const editorStateInitialValues = EditorState.createWithContent(content)
        setEditorState(editorStateInitialValues)
      } else {
        setEditorState(EditorState.createWithContent(convertFromRaw(contentForOldListing)))
      }
    }
  }, [])

  const handleEditorChange = (state) => {
    setEditorState(state);
    return input.onChange(JSON.stringify(convertToRaw(state.getCurrentContent())))
  }

  return (
    <div className={css.root}>
      {!!label &&
        <label
          className={classNames(css.label, {[css.isRequired] : isRequired})}>
          {label}
        </label>
      }
      <Editor
        editorState={editorState}
        onEditorStateChange={handleEditorChange}
        wrapperClassName={css.editorWrapper}
        editorClassName={css.editor}
        toolbar={editorToolbarOptions}
        placeholder={placeholder || null}
        stripPastedStyles={true}
      />
    </div>
  )
}

export default TextEditor;
